module.exports = __webpack_public_path__ + "img/banner-img.gif?2f0c34f9873e603ecb4a16373c879def";